export const mixPanelEvents = {
    LOGGED_IN: 'Logged In',
    LOGGED_OUT: 'Logged Out',
    ADD_ESTIMATE: 'Add Estimate',
    UPLOAD_IMPORTER: 'Upload Estimate Importer',
    SAVE_ESTIMATE_IMPORTER_PREVIEW: 'Save Estimate Importer Preview',
    SAVE_ESTIMATE_IMPORTER: 'Save Estimate Importer',
    ADD_EQUIPMENT_CATEGORY: 'Add Equipment Category',
    ARCHIVE_EQUIPMENT_CATEGORY: 'Archive Equipment Category',
    EDIT_EQUIPMENT_CATEGORY: 'Edit Equipment Category',
    ARCHIVE_EQUIPMENT: 'Archive Equipment',
    EDIT_EQUIPMENT: 'Edit Equipment',
    ADD_EQUIPMENT: 'Add Equipment',
    UPLOAD_EQUIPMENT: "Upload Equipment",
    ADD_MATERIAL: 'Add Material',
    EDIT_MATERIAL: 'Edit Material',
    UPLOAD_MATERIAL: 'Upload Material',
    ARCHIVE_MATERIAL: 'Archive Material',
    EDIT_MATERIAL_TYPE: 'Edit Material Type',
    ADD_MATERIAL_TYPE: 'Add Material Type',
    UPLOAD_MANPOWER: 'Upload Manpower',
    ADD_MANPOWER: 'Add Manpower',
    EDIT_MANPOWER: 'Edit Manpower',
    ADD_MANPOWER_POSITION: 'Add Manpower Position',
    DOWNLOAD_ATTENDANCE: 'Download Attendance',
    CLICKED_SLIPPAGE: 'Clicked Slippage',
    REQUEST_MATERIAL: 'Request Material',
    REQUEST_EQUIPMENT: 'Request Equipment',
    SAVE_WEEKLY: 'Save Weekly',
    SAVE_TWO_WEEKS: 'Save Two Weeks',
    SAVE_HISTORICAL : 'Save Historical Reports',
    ADD_MATERIAL_INBOUND: 'Add Material Inbound',
    EDIT_MATERIAL_INBOUND: 'Edit Material Inbound',
    ADD_MATERIAL_UTILIZATION: 'Add Material Utilization',
    EDIT_MATERIAL_UTILIZATION: 'Edit Material Utilization',
    REVERSE_MATERIAL_UTILIZATION: 'Reverse Material Utilization',
    ADD_EQUIPMENT_DAILY_ACTIVITY: 'Add Equipment Daily Activity',
    EDIT_EQUIPMENT_DAILY_ACTIVITY: 'Edit Equipment Daily Activity',
    VIEW_RISK_PROFILE: 'View Risk Profile',
    CLICKED_DIVERSION: 'Clicked Diversion Recommendation',
    CLICKED_CATCH_UP_PLAN: 'Clicked Catch Up Plan Recommendation',
    POST_PROJECT_UPDATE: 'Post Project Update',
    REPLY_PROJECT_UPDATE: 'Reply Project Update',
    LIKE_PROJECT_UPDATE: 'Like Project Update',
    DOWNLOAD_DETAILED_ESTIMATE: 'Download Detailed Estimate Report',
    DOWNLOAD_BOM: 'Download BOM Report',
    DOWNLOAD_BOQ: 'Dowload BOQ Report',
    USER_NAVIGATE: 'User Navigate',
    DOWNLOAD_TWO_WEEKS: 'Download Two Weeks Report',
    DOWNLOAD_WEEKLY: 'Download Weekly Report',
    USE_CALCULATOR: 'Use Calculator',
    SAVE_SOW: 'Save Scope of Work',
    ADD_SCOPE_OF_WORK: 'Add Scope of Work',
    EDIT_SCOPE_OF_WORK: 'Edit Scope of Work',
    ADD_WORK_ITEM: 'Add Work Item',
    EDIT_WORK_ITEM: 'Edit Work Item',
    DELETE_SCOPE_OF_WORK: 'Delete Scope of Work',
    DELETE_WORK_ITEM: 'Delete Work Item',
    SAVE_WORK_BREAKDOWN: 'Save Work Breakdown',
    UPLOAD_WORK_BREAKDOWN: 'Upload Work Breakdown',
}
